import React, { Component } from "react";
import clsx from 'clsx';
import { makeStyles, withStyles, useTheme, styled } from '@material-ui/core/styles';
import Save from '../../../../../assets/img/svg/save.svg';
import Cancel from '../../../../../assets/img/svg/cancel.svg';
import Delete from '../../../../../assets/img/svg/delete.svg'
import deactive from '../../../../../assets/img/svg/deactive.svg';

import download from "../../../../../assets/img/svg/DownloadIcon.svg"
import image from '../../../../../assets/img/svg/Image.svg';
import Ship from "../../../../../assets/img/svg/Ship.svg";
import { Tabs, Tab, AppBar, Typography, Box } from '@material-ui/core';
import PropTypes from 'prop-types';
import del from "../../../../../assets/img/svg/Del.svg"
import { useNavigate } from "react-router-dom";
import withRouter from "../../../../custom/withRouter";
import { connect } from "react-redux";
//mport PropTypes from 'prop-types';
import styles from "../../../../../assets/jss/customStyle";
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery";
import { getSettingsFormat } from "../../../../../actions/SettingsAction"

import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Autocomplete from "react-autocomplete"
import moment from "moment"
import { getprojectdisprodocinfo, gethistorylogdisproinfo, filedeletedispro } from "../../../../../actions/DismantlingAction";
import axios from "axios";
import API from "../../../../../_helpers/endpointService";
import InnerImageZoom from "react-inner-image-zoom";
import { IndeterminateCheckBoxTwoTone } from "@material-ui/icons";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: "none !important"
    },
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    indicator: {
        backgroundColor: "#00838F",
    },
}));

class EditDISPRO extends Component {
    constructor(props) {
        super(props);
        this.inputFile = React.createRef();
        this.state = {
            value: 0,
            isMobile: false,
            isView: false,
            isError: false,
            Docs: [],
            ProjectId: 0,
            filename: "",
            awsname: "",
            DelIndex: 0,
            index: 0,
            cancel: false,
            DateError: false,
            DescriptionError: false,
            DismantledError: false,
            UserRole: "",
            addData: {
                "Id": 0,
                "ProjectId": 0,
                "Date": "",
                "Description": "",
                "DismantledTons": "",
                "Title": "",
                "LightshipWeight": 0,
                "DismantledTonsPercentage": "",
                "ModifiedBy": ''
            }
        }
    }

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
        })
        if (this.state.value == 1) {
            this.props.dispatch((gethistorylogdisproinfo(this.state.addData.ProjectId)))
        }
        else {
            // this.getdisprodocinfo(localStorage.getItem("DISPROEditId"))
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        this.state.addData.ModifiedBy = localStorage.getItem("UserRoles");
        this.state.addData.ProjectId = parseInt(localStorage.getItem("DashId"))
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        this.getdisprodocinfo(localStorage.getItem("DISPROEditId"))
        this.props.dispatch((gethistorylogdisproinfo(this.state.addData.ProjectId)))
        this.props.dispatch(getSettingsFormat(this.state.addData.ProjectId))
        window.location.pathname == '/dismantlingprogress/edit' ? this.setState({ isView: false }) : this.setState({ isView: true })
        this.state.addData.Id = parseInt(localStorage.getItem("DISPROEditId"));
        this.setState({})
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }

    getdisprodocinfo = (id) => {
        let apiUrl = API.DISMANTLING_PROGRESS + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.state.addData.Date = response.data.Date ? response.data.Date : null;
                    this.state.addData.Description = response.data.Description ? response.data.Description : "";
                    this.state.addData.DismantledTons = response.data.DismantledTons ? response.data.DismantledTons : 0;
                    this.state.addData.Title = response.data.Title ? response.data.Title : "";
                    this.state.addData.Comments = response.data.Comments ? response.data.Comments : "";
                    this.state.addData.DismantledTonsPercentage = response.data.DismantledTonsPercentage ? response.data.DismantledTonsPercentage : 0;
                    this.state.addData.LightshipWeight = response.data.LightshipWeight;
                    this.setState({})
                    if (response.data.Drawings.length > 0 && response.data.Drawings !== undefined) {
                        response.data?.Drawings.map((i) => {
                            i.FileName = i.FileName;
                            i.ObjectKey = i.ObjectKey;
                            i.AwsFolderName = i.AwsFolderName;
                            i.AwsUniqueFileName = i.AwsUniqueFileName;
                            i.FileExtention = i.FileExtention;
                            i.FileUrl = i.FileUrl;
                            i.check = false;
                        })
                        this.state.Docs = response.data?.Drawings;
                    }
                    this.setState({})
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#DISPR1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dispro1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Dispro").addClass("d-none");
        $("#Dispro").removeClass("d-block");
        $("#DISPL").removeClass("active-color");
        $("#DISPT").removeClass("fw-bolder");
    }

    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.navigate("/sidebar");
        }

    };
    SideBarCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        this.props.navigate("/sidebar");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }

    };
    resize1 = () => {
        $("#DISPR1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Dispro1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Dispro").removeClass("d-none");
        $("#Dispro").addClass("d-block");
        $("#DISPL").addClass("active-color");
        $("#DISPT").addClass("fw-bolder");
    }
    EditCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate("/dismantlingprogress")
    };
    EditCancel1 = () => {
        if (this.state.value == 1) {
            this.state.value = 0
            this.setState({})
            this.getdisprodocinfo(localStorage.getItem("DISPROEditId"))
        }
        else {
            if (this.state.cancel == true) {
                window.$("#cancelpopup").modal("show");
            }
            else {
                this.props.dispatch({ type: "CANCEL", data: false });
                this.props.navigate("/dismantlingprogress")
            }
        }
    };
    ViewCancel = () => {
        this.props.navigate("/dismantlingprogress")
    }
    AttachFiles = (e) => {
        this.inputFile.current.click();
    };

    setCheckbox = (index) => {
        this.state.Docs.map((i, ind) => {
            if (ind == index) {
                i.check = !i.check;
                this.setState({});
            }
        })
    };

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    UploadFile = (e) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (this.state.Docs.length != 5) {
            Array.from(e.target.files).forEach(async (a) => {
                let upload = {
                    FileName: a.name,
                    FileSize: a.size,
                    check: false,
                    fdata: a,
                    FileUrl: await this.toBase64(a),
                }
                this.state.Docs.push(upload)
                this.setState({})
            })
        }
        else {
            window.$("#Informationpopup").modal("show")
        }
    };
    Cancel = () => {
        window.$("#Informationpopup").modal("hide")
    }
    handleInputChange = (e, str) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (str == "Description") {
            if (e.target.value.length - 1 < 500) {
                this.state.addData[str] = e.target.value;
                this.setState({});
            }
        }
        else if (str == "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData[str] = e.target.value;
                this.setState({});
            }
        }
        else {
            this.state.addData[str] = e.target.value;
            this.setState({})
        }
    };

    handleInputChange1 = (e, str) => {
        this.state.cancel = true;
        this.props.dispatch({ type: "CANCEL", data: true });
        if (e.target.value == "") {
            this.state.addData[str] = "";
            this.setState({})
        }
        else {
            this.state.addData[str] = parseFloat(e.target.value);
            this.setState({})
        }
        if (isNaN(this.state.addData[str])) {
            this.state.addData.DismantledTonsPercentage = '';
            this.state.addData[str] = "";
            this.setState({})

        }

        if (this.state.addData.DismantledTons != "") {
            if (this.state.addData.LightshipWeight == 0) {
                this.state.addData.DismantledTonsPercentage = ''
                this.setState({})
            }
            else {

                this.state.addData.DismantledTonsPercentage = parseFloat(this.state.addData.DismantledTons / this.state.addData.LightshipWeight)
                this.state.addData.DismantledTonsPercentage = parseFloat(this.state.addData.DismantledTonsPercentage * 100).toFixed(2)
                this.setState({})
            }

        }
        else {
            this.state.addData.DismantledTonsPercentage = ''
            this.setState({})
        }
    };
    openView = (url, name, ind) => {
        this.state.fileUrl = url;
        this.state.fileName = name;
        this.state.index = ind;
        this.setState({})
        window.$('#viewscreen').modal('show')
    }
    nextView = (ind) => {
        if (this.state.Docs.length === ind) {
            this.setState({
                index: 0
            })
        }
        else {
            this.setState({
                index: ind
            })
        }

    }
    preView = (ind) => {
        if (ind === -1) {
            this.setState({
                index: this.state.Docs.length - 1
            })
        }
        else {
            this.setState({
                index: ind
            })
        }

    }
    setIndex = (ind) => {
        this.setState({
            index: ind
        })
    }
    OpenPopup = (filename, awsname, id, index) => {
        this.state.filename = filename;
        this.state.awsname = awsname;

        this.state.DelIndex = index;
        this.setState({})
        window.$("#deletepopupfile").modal("show");
    }

    DeleteItem = () => {
        this.state.cancel = true;
        let tempData = [];
        this.state.Docs.map((i, index) => {
            if (this.state.DelIndex == index) {
                if (i.AwsUniqueFileName == this.state.awsname && this.state.awsname != undefined) {
                    this.props.dispatch(filedeletedispro(this.state.addData.Id, this.state.awsname))
                }
            }
            if (this.state.DelIndex != index) {
                tempData.push(i)
            }
        })
        this.state.Docs = tempData;
        this.setState({})
        window.$("#deletepopupfile").modal("hide");
    }

    OpenPopup1 = () => {
        window.$("#deletepopuprow").modal("show");
    }

    DeleteItem1 = () => {
        this.DeleteItems(this.state.addData.Id, this.state.UserRole)
        window.$("#deletepopuprow").modal("hide");
    }

    DeleteItems = (data, name) => {
        let apiUrl = API.DISMANTLING_PROGRESS + '/' + data + '?modify=' + name;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    let temp = {
                        Description: "",
                        DateTimeFrom: "",
                        DateTimeTo: "",
                        PageNumber: 1,
                        PageSize: 10,
                    }
                    this.props.dispatch(getprojectdisprodocinfo(temp, this.state.ProjectId))
                    this.props.navigate(`/dismantlingprogress`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    EditSave = () => {
        if (this.state.addData.Description.trim() === "") {
            this.state.DescriptionError = true;
            this.state.addData.Description = this.state.addData.Description.trim();
            this.setState({})
        }
        else {
            this.state.DescriptionError = false;
            this.state.addData.Description = this.state.addData.Description.trim();
            this.setState({})
        }
        if (this.state.addData.DismantledTons == "") {
            this.state.DismantledError = true;
            this.setState({})
        }
        else {
            this.state.DismantledError = false;
            this.setState({})
        }
        if (this.state.addData.Date == "") {
            this.state.DateError = true;
            this.setState({})
        }
        else {
            this.state.DateError = false;
            this.setState({})
        }
        if (this.state.addData.Description !== '' && this.state.addData.Date !== '' && this.state.addData.DismantledTons !== "") {
            this.props.dispatch({ type: "CANCEL", data: false });
            let formData = new FormData()
            let array = [];
            Array.from(this.state.Docs).forEach(async (a) => {
                if (a.AwsUniqueFileName == undefined) {
                    formData.append("drawings", a.fdata)
                    array.push(a)
                }
            })
            if (this.state.addData.Title != "" || this.state.addData.Title != null) {
                this.state.addData.Title = this.state.addData.Title.trim();
            }
            if (this.state.addData.Comments != "" || this.state.addData.Comments != null) {
                this.state.addData.Comments = this.state.addData.Comments.trim();
            }
            this.setState({})
            this.adddwprdocinfo(this.state.addData, formData, this.state.addData.Id, array)
        }
    }

    adddwprdocinfo = (data, formData, id, array) => {
        let apiUrl = API.DISMANTLING_PROGRESS + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "PUT",
            url: apiUrl,
            data: data,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    if (array.length > 0) {
                        this.adduploaddwprdocinfo(formData, id)
                    }
                    else {

                        this.props.navigate("/dismantlingprogress")
                    }
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {

                }
            });
    };

    adduploaddwprdocinfo = (data, id) => {
        let apiUrl = API.DISMANTLING_PROGRESS + '/' + id;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,

        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (response?.status === 200) {
                    this.props.navigate("/dismantlingprogress")

                } else {

                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })

                if (error?.response?.status === 401) {

                }
            });
    };

    render() {
        let { classes, menuToggle } = this.props;
        const { isView, isEdit, isMobile, isError } = this.state;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"DISPR" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="DISPR" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>{this.state.isView ? "Dismantling Progress" : "Edit Dismantling Progress"}</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ? <table className="dataTable border-top" width="100%">
                        <tbody>
                            <tr>
                                {this.state.value == 1 ? <>
                                    <td width="5%" className="border-right">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={() => this.EditCancel1()}></i></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </> : <>
                                    {this.state.isView ? <><td className=" border-right" width="5%">
                                        <i class="fa fa-arrow-left cursorPointer" onClick={this.ViewCancel}></i></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </>
                                        :
                                        <td className="border-right text-center">
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel1}></i></td>
                                    }
                                </>}
                                {this.state.isView ? <></> : <> {this.state.value == 1 ? <></> : <><td className="border-right text-center">
                                    <span className={classes.button} onClick={this.EditSave} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</span>
                                </td>
                                    <td className="border-right text-center">
                                        <span className={`${classes.button}`} onClick={this.EditCancel1} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</span>
                                    </td>
                                    <td className="border-right text-center">
                                        <span className={`${classes.button}`} style={{ minWidth: '70px' }} onClick={() => { this.OpenPopup1() }} ><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</span> </td>
                                </>} </>}

                            </tr>
                        </tbody>
                    </table>
                        : <table className="dataTable" width="100%">
                            <tbody>
                                <tr>
                                    <td width="5%" className="border-right text-center">
                                        {this.state.isView ?
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.ViewCancel}></i>
                                            :
                                            <i class="fa fa-arrow-left cursorPointer" onClick={this.EditCancel1}></i>
                                        }
                                    </td>
                                    <td width="95%">

                                        {this.state.isView ? <></> : <>
                                            {this.state.value == 1 ? <></> : <>
                                                <button className={classes.button} onClick={this.EditSave}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} onClick={this.EditCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                            </>}</>}
                                        {this.state.isView ? <></> : <>{this.state.value == 1 ? <></> : <>
                                            <button className={`${classes.button} pl-3`} onClick={() => { this.OpenPopup1() }} ><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete</button></>}
                                        </>}
                                    </td>
                                </tr>
                            </tbody>
                        </table>}
                    <div style={{ margin: this.state.isMobile ? "0" : "5px" }}>
                        {this.state.isMobile ? <></> : <h6 className="col-12 mt-3 ml-2">{this.state.isView ? "Dismantling Progress" : "Edit Dismantling Progress"}</h6>}
                    </div>
                    <div className="row ">
                        <div>
                            {this.state.isView ? <>
                            </> : <>
                                <AppBar position="static" color="inherit" className={classes.root} style={{ margin: '0', maxHeight: '0px' }}>
                                    <Tabs
                                        value={this.state.value}
                                        onChange={this.handleChange}
                                        classes={{ indicator: classes.indicator }}
                                    >
                                        <Tab className="ml-4" label="Details" style={{ textTransform: "none", minWidth: '13px' }} {...a11yProps(0)} />
                                        <Tab label="History log" style={{ textTransform: "none", minWidth: '13px' }} {...a11yProps(1)} />
                                    </Tabs>
                                </AppBar>
                            </>}
                            <TabPanel value={this.state.value} index={0}>
                                <div className={this.state.isMobile ? this.state.isView ? "row mt-n3" : "row px-0 mt-3" : this.state.isView ? "row px-0 mx-0 mt-n4" : "row px-0 mx-0 mt-4"}>
                                    <div className={`row mx-0 mt-2 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-top"}`}>
                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 px-0"}`}>
                                            <label className={this.state.isMobile ? "d-flex mt-2" : "float-end d-flex text-right m-0"}>Date :
                                                {isView ? <></> : <div className={`${classes.helperText}`}>
                                                    <div className="MuiFormHelperText-contained">*</div>
                                                </div>}
                                            </label>
                                        </div>
                                        {isView ?
                                            <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                <TextField
                                                    type="text"
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    disabled

                                                    value={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    InputProps={{
                                                        className: `border-radius view-color ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                            </div> :
                                            <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                {this.state.DateError ?
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        error
                                                        type="date"
                                                        id="type-date"
                                                        value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                                        placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                        onChange={(e) => { this.handleInputChange(e, "Date") }}
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                        inputProps={{
                                                            max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                            min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                          }}
                                                    />
                                                    :
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        type="date"
                                                        id="type-date"
                                                        value={this.state.addData.Date && moment(this.state.addData.Date).format("yyyy-MM-DD")}
                                                        placeholder={this.state.addData.Date && moment(this.state.addData.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                        onChange={(e) => { this.handleInputChange(e, "Date") }}
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                        inputProps={{
                                                            max: `${JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}`,
                                                            min: `${JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}`,
                                                          }}
                                                    />
                                                }
                                            </div>}
                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                            <label className={this.state.isMobile ? "d-flex mt-2" : "float-end d-flex text-right m-0"}>Dismantled Tons&nbsp;:
                                                {isView ? <></> :
                                                    <div className={`${classes.helperText}`}>
                                                        <div className="MuiFormHelperText-contained">*</div>
                                                    </div>
                                                }
                                            </label>
                                        </div>
                                        {isView ?
                                            <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                <TextField
                                                    type="text"
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    disabled

                                                    value={this.state.addData.DismantledTons}
                                                    InputProps={{
                                                        className: `border-radius view-color ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                            </div> :
                                            <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                {this.state.DismantledError ?
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        error
                                                        placeholder="0.0"
                                                        step="any"
                                                        value={this.state.addData.DismantledTons}
                                                        onChange={(e) => { this.handleInputChange1(e, "DismantledTons") }}
                                                        type="number"
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                    :
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        type="number"
                                                        fullWidth
                                                        placeholder="0.0"
                                                        step="any"
                                                        value={this.state.addData.DismantledTons}
                                                        onChange={(e) => { this.handleInputChange1(e, "DismantledTons") }}
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                }
                                            </div>}
                                        {isView ? <>
                                            <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "col-md-2"}`}>
                                                <label className={this.state.isMobile ? "mt-2" : "float-end text-right m-n2"}>%Dismantled&nbsp;:</label>
                                            </div>
                                            <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right  col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                <TextField
                                                    type="text"
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    disabled
                                                    placeholder="0"

                                                    value={this.state.addData.DismantledTonsPercentage}
                                                    InputProps={{
                                                        className: `border-radius view-color ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                            </div></> : <>
                                            <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : " col-md-2"}`}>
                                                <label className={this.state.isMobile ? "mt-2" : "float-end m-n2 text-right"}>%Dismantled&nbsp;:</label>
                                            </div>
                                            <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right  col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    disabled
                                                    placeholder="0"
                                                    value={this.state.addData.DismantledTonsPercentage}
                                                    InputProps={{
                                                        className: `border-radius view-color ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                            </div>
                                        </>}
                                    </div>

                                    <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-top border-bottom"}`}>
                                        <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2 mt-n3 px-0"}`}>
                                            <label className={this.state.isMobile ? "d-flex mt-2" : "float-end d-flex text-right"}>Description&nbsp;:
                                                {isView ? <></> : <div className={`${classes.helperText}`}>
                                                    <div className="MuiFormHelperText-contained">*</div>
                                                </div>}
                                            </label>
                                        </div>
                                        {isView ?
                                            <div className={`col-12 col-sm-12  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-10 pt-4 pb-4"}`}>
                                                <TextField
                                                    multiline
                                                    rows={4}
                                                    variant="outlined"
                                                    size="small"
                                                    disabled
                                                    fullWidth
                                                    value={this.state.addData.Description}
                                                    InputProps={{
                                                        className: `border-radius view-color ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                            </div> :
                                            <div className={`col-12 col-sm-12  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                {this.state.DescriptionError ?
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        error
                                                        multiline
                                                        rows={4}
                                                        value={this.state.addData.Description}
                                                        onChange={(e) => { this.handleInputChange(e, "Description") }}
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                    :
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        multiline
                                                        rows={4}
                                                        value={this.state.addData.Description}
                                                        onChange={(e) => { this.handleInputChange(e, "Description") }}
                                                        InputProps={{
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }}
                                                    />
                                                }
                                                {isView ? <></> : <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Description?.length == undefined ? 500 - 0 : 500 - this.state.addData?.Description?.length}/500 Characters left</label>}

                                            </div>}
                                    </div>
                                    {isView ? <></> : <>
                                        <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                            <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                <label className={this.state.isMobile ? "mt-2" : "float-end mt-n4 text-right"}>Comments&nbsp;:</label>
                                            </div>
                                            <div className={`col-12 col-sm-12  col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-10 pt-4"}`}>
                                                <TextField
                                                    multiline
                                                    rows={8}
                                                    variant="outlined"
                                                    size="small"
                                                    value={this.state.addData.Comments}
                                                    onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                                    fullWidth
                                                    InputProps={{
                                                        className: `border-radius ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                                {isView ? <></> : <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>}

                                            </div>
                                        </div></>}

                                    {isView ? this.state.addData.Title === "" && (this.state.Docs.length === 0 || this.state.Docs === null) ? <></> : <>
                                        <div className={this.state.isMobile ? "col-12 col-xs-12 pt-4 pb-2 px-3" : "col-12 col-xs-12 pt-4 pb-2 px-1"}>
                                            <h6 className="font">Drawings</h6>
                                        </div>
                                    </> :
                                        <>
                                            <div className={this.state.isMobile ? "col-12 col-xs-12 pt-4 pb-2 px-3" : "col-12 col-xs-12 pt-4 pb-2 px-1"}>
                                                <h6 className="font">Drawings</h6>
                                            </div>
                                        </>}
                                    {isView ? this.state.addData.Title === "" ? <></> : <>
                                        <div className={`row mt-2 mx-0 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                            <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right border-top" : "mt-2 col-md-2 "}`}>
                                                <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>Title&nbsp;:</label>
                                            </div>
                                            <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                <TextField
                                                    type="text"
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    disabled
                                                    value={this.state.addData.Title}
                                                    InputProps={{
                                                        className: `border-radius view-color ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                        :
                                        <div className={`row mt-2 mx-0 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                            <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right border-top" : "mt-2 col-md-2 "}`}>
                                                <label className={this.state.isMobile ? "mt-2" : "float-end text-right"}>Title&nbsp;:</label>
                                            </div>
                                            <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                                <TextField
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    value={this.state.addData.Title}
                                                    onChange={(e) => { this.handleInputChange(e, "Title") }}
                                                    InputProps={{
                                                        className: `border-radius ${classes.inputfieldAlign}`
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    }


                                    {isView ?
                                        this.state.Docs.length === 0 || this.state.Docs === null ? <></> : <>
                                            <div className={`row mx-0 align-items-center ${this.state.isMobile ? "" : this.state.addData.Title === "" ? "border-left border-right border-top border-bottom" : "border-left border-right  border-bottom"}`}>
                                                {/* <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? this.state.addData.Title === "" ? "border-top border-left border-right" : "border-left border-right" : " col-md-2 px-0 "}`}>
                                                    <label className={this.state.isMobile ? "mt-2" : "mt-2"}>Drawings&nbsp;:</label>
                                                </div> */}
                                                {/* <div className={`col-12 col-sm-12  col-md-12 col-lg-10 col-xl-11 align-items-center ${this.state.isMobile ? "border-left border-right  border-bottom" : "pt-2 col-md-2"}`}> */}
                                                {/* <div className={this.state.Docs.length == 0 ? "row px-1 mt-4 pt-5" : "row px-1"}>
                                                        {this.state.Docs && this.state.Docs.map((i,ind) => (
                                                            <div className={`col-6 col-sm-4 col-lg-3 col-xl-2 align-items-center border-right  px-1 mt-1 mb-2 ${this.state.isMobile ? "col-md-4 " : "col-md-4"}`}>
                                                                <div className="row d-flex">
                                                                    <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" onClick={() => { this.openView(i.FileUrl, i.FileName,ind) }}>
                                                                        <img className="cursorPointer" src={i.FileUrl} onClick={() => { this.openView(i.FileUrl, i.FileName,ind) }} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                                    </div>
                                                                    <div className="col-8 col-sm-8 col-lg-8 col-xl-8 col-md-8">
                                                                        <div onClick={() => { this.openView(i.FileUrl, i.FileName,ind) }} className="cursorPointer overflow pt-2 ml-3">{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}

                                                    </div> */}
                                                <div className={`col-12 col-sm-12  col-md-12  col-lg-12 col-xl-12 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2 px-0"}`}>

                                                    {this.state.Docs && this.state.Docs.map((i, ind) => (<>
                                                        <div className="text-row px-0 pt-2 mb-3 pb-2 text-center">
                                                            <img className="img-fluid px-2 " src={i.FileUrl} onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }}></img>
                                                        </div>
                                                    </>))}
                                                </div>

                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className={`row mx-0  ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2"}`}>
                                                    <label className={this.state.isMobile ? " mt-2" : "float-end pt-4 text-right"}>Drawings&nbsp;:</label>
                                                </div>
                                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-1 pb-3" : "col-md-4 pt-4"}`}>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                        disabled
                                                        onChange={(e) => this.UploadFile(e)}
                                                        accept=".png,.jpg"
                                                        placeholder="Browse File"
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment className="mr-0">
                                                                    <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                                        <AttachFileIcon />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            ),
                                                            className: `border-radius ${classes.inputfieldAlign}`
                                                        }} />
                                                    <input
                                                        type="file"
                                                        hidden
                                                        multiple="multiple"
                                                        accept=".png,.jpg"
                                                        onChange={(e) => this.UploadFile(e)}
                                                        ref={this.inputFile}
                                                    />
                                                </div>
                                                {/* <div className={`col-12 col-sm-12  col-md-12 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                                    <div className={this.state.isMobile ? "row pl-2 pr-3" : "row px-1"}>
                                                        {this.state.Docs && this.state.Docs.map((i, ind) => {
                                                            return (
                                                               
                                                                <div className={`col-12 col-sm-4 col-lg-6 col-xl-3 align-items-center border-right  px-1 mt-1 mb-2 ${this.state.isMobile ? "col-md-4 " : "col-md-4"}`}>
                                                                    <div className="row d-flex">
                                                                        <div className="col-2 col-sm-2 col-lg-2 col-xl-2 col-md-2 pt-1 mt-3" onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }}>
                                                                            <img className="cursorPointer" src={i.FileUrl} onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                                        </div>
                                                                        <div className="col-8 col-sm-8 col-lg-8 col-xl-8 col-md-8">
                                                                            <div onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }} className="cursorPointer overflow pt-2 ml-3">{i.FileName}<br></br><label style={{ color: "#B0AAAA", fontSize: '10px' }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                                        </div>
                                                                        <div className="col-1 col-sm-1 col-lg-1 col-xl-1 col-md-1 pl-1 mt-2 pt-2 pr-2">
                                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(i.FileName, i.AwsUniqueFileName, i.Id, ind) }} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )

                                                        })}
                                                    </div>
                                                </div> */}
                                                <div className={`col-12 col-sm-12  col-md-12  col-lg-12 col-xl-12 ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2 px-0"}`}>

                                                    {this.state.Docs && this.state.Docs.map((i, ind) => (<>
                                                        <div className="text-right pb-1 px-0">
                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(i.FileName, i.AwsUniqueFileName, i.Id, ind) }} />
                                                        </div>
                                                        <div className="text-row px-0 pt-2 mb-3 pb-2 text-center">
                                                            <img className="img-fluid px-2 " src={i.FileUrl} onClick={() => { this.openView(i.FileUrl, i.FileName, ind) }}></img>
                                                        </div>
                                                    </>))}
                                                </div>
                                            </div>
                                        </>
                                    }


                                </div>


                            </TabPanel>
                            <TabPanel value={this.state.value} index={1}>
                                <div className="row">
                                    <div className="mt-3 pt-3">
                                        <div className="col-sm-12 col-12 px-0">
                                            <div className="table-responsive mb-4" style={{ width: "100%" }}>
                                                <table id="dataTable" className="table">
                                                    <thead>
                                                        <tr className="">
                                                            <th className="border-top border-right border-left" style={{ width: '15%', minWidth: '160px' }}><span className="spandoc-thead" style={{ color: "#000000" }}>Timestamp</span></th>
                                                            <th className="border-top border-right" style={{ width: '10%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Action</span></th>
                                                            <th className="border-top border-right" style={{ width: '15%', minWidth: window.innerWidth < 1000 ? '135px' : "" }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Action by</span></th>
                                                            <th className="border-top border-right" style={{ width: '60%', minWidth: window.innerWidth < 1000 ? '400px' : "" }}><span className="spandoc-thead" style={{ color: "#000000" }}>Comments</span></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ fontFamily: 'Segoe UI' }}>
                                                        {this.props.historyLog && this.props.historyLog.map((i) => (
                                                            <tr>
                                                                <td className="spandoc-td border-right border-left align-middle Nowrap">
                                                                    {moment(i.TimeStamp).format(this.props.settings.Convention ? this.props.settings.Convention + " hh:mm:ss A" : "DD/MM/YYYY hh:mm:ss A")}
                                                                </td>
                                                                <td className="spandoc-td border-right align-middle">{i.Action}</td>
                                                                <td className="spandoc-td border-right align-middle">{i.ActionBy}</td>
                                                                <td className="spandoc-td border-right align-middle">{i.Comments}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </TabPanel>
                        </div>
                    </div >
                    <div class="modal fade p-5 mt-5" id="deletepopupfile" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#deletepopupfile").modal("hide"); }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="deletepopuprow" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                        {/* <i class="bi bi-check-circle-fill text-success"></i> */}
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem1}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => { window.$("#deletepopuprow").modal("hide"); }} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade " id="viewscreen" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                        <div class="modal-dialog modal-lg " role="document">
                            <div class="modal-content ">
                                <div class="modal-body pt-0 pb-2 pr-0 pl-0 ">
                                    <div className="row">
                                        <div className="col-12 ">
                                            <div className='cursorPointer float-end mr-3' id="viewscreen" onClick={() => {
                                                window.$('#viewscreen').modal('hide')

                                            }} >
                                                <button className={`${classes.button} px-0 hidefield`} >&nbsp;Close</button>
                                            </div>
                                        </div>
                                        <div className='col-12 text-center'>
                                            <div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel" style={{}} >
                                                <div class="carousel-indicators">

                                                </div>
                                                <div class="carousel-inner" >
                                                    {this.state.Docs && this.state.Docs.map((i, ind) => (<>
                                                        <div class={ind === this.state.index ? "carousel-item active col-12 text-center align-middle" : " align-middle carousel-item col-12 text-center"}>
                                                            <div>
                                                                <InnerImageZoom
                                                                    moveType="drag"
                                                                    zoomScale={2}
                                                                    hideCloseButton={true}
                                                                    src={i.FileUrl}
                                                                    hasSpacer={true}
                                                                    afterZoomIn={() => { $('#viewscreen > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                                                    afterZoomOut={() => { $('#viewscreen > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                                                />
                                                            </div>
                                                            {this.state.Docs.length <= 1 ? "" : <>
                                                                <button class="carousel-control-prev my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.preView(ind - 1)} data-bs-slide="prev">
                                                                    <span class="carousel-control-prev-icon black" aria-hidden="true"></span>
                                                                    <span class="visually-hidden">Previous</span>
                                                                </button>
                                                                <button class="carousel-control-next  my-5 hidefield" type="button" data-bs-target="#carouselExampleCaptions" onClick={() => this.nextView(ind + 1)} data-bs-slide="next">
                                                                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                                                    <span class="visually-hidden">Next</span>
                                                                </button>
                                                            </>}
                                                        </div>
                                                    </>))}
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.EditCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="Informationpopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>

                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>

                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">You can't add more than 5 drawings</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" id="closemodal3" class={this.state.isMobile ? "btn btn-secondary text-center" : " btn btn-secondary py-2 px-4 text-center"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.Cancel()}><span className="" >Ok</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        historyLog: state.commonReducer.historyLog || [],
        settings: state.commonReducer.settings || [],
    };
}

EditDISPRO.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditDISPRO))
);